import { IdType, idTypeActions } from "../../domain/idType";
import idTypes from "../config/idTypes.json"

export const idTypeService = {
  async execute(): Promise<IdType[]> {
    const idTypeOptions: IdType[] = idTypes;

    return new Promise((resolve) => {
      resolve(
        idTypeOptions.map((idType) => {
          return idTypeActions().idType(
            idType.idType,
            idType.type
          );
        })
      );
    });
  },
};
